import { combineReducers, createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { reducer as reduxFormReducer } from 'redux-form';
import {
  cryptoTableReducer,
  newOrderTableReducer,
  sidebarReducer,
  themeReducer,
  customizerReducer,
  todoReducer,
  rtlReducer,
  authReducer,
} from '../../redux/reducers/index';
import covidReducer from '../Maps/VectorMapWithRequestData/redux/covidReducer';
import frontsideSideBooking from '../../store/reducers/frontsideSideBooking';
import auth from '../../store/reducers/auth';
import seatMapTablesReducer from '../../store/reducers/seatMapTablesReducer';
import qrFrontSideReducer from '../../store/reducers/qrFrontSideReducer';


const reducer = combineReducers({
  form: reduxFormReducer, // mounted under "form",
  theme: themeReducer,
  rtl: rtlReducer,
  sidebar: sidebarReducer,
  cryptoTable: cryptoTableReducer,
  newOrder: newOrderTableReducer,
  customizer: customizerReducer,
  todos: todoReducer,
  user: authReducer,
  covid: covidReducer,
  frontsideSideBooking,
  seatMapTablesReducer,
  qrFrontSideReducer,
  auth,
});

const store = createStore(reducer, applyMiddleware(thunk));

export default store;
